import styled, { css } from "styled-components";
import { designTokens } from "../ui/foundation/DesignTokens";

export const WhatsappTemplateSelectContainer = styled.section`
  z-index: 1;
  background-color: white;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 16px 16px 72px 16px;
  flex: 1;
  min-height: 0;
  height: auto;
  display: flex;
  flex-direction: column;
  gap: 12px;
  -webkit-overflow-scrolling: touch;

  ${(props) =>
    props.isFromModal &&
    css`
      flex: none;
      max-height: 40vh;
      padding-bottom: 24px;
    `}

  ${(props) =>
    props.iswhatsappTemplateSelected &&
    css`
      padding-bottom: 32px;
    `}
`;

export const WhatsappTemplateSelectorContainer = styled.div`
  background-color: white;
  width: 100%;
  flex: 1;
  min-height: 0;
  height: 100%;
  max-height: 100%;
  border-radius: ${designTokens.radius.md};
  border: 1px solid ${designTokens.colors.gray[200]};
  display: flex;
  flex-direction: column;
  overflow: hidden;

  ${(props) =>
    props.isFromModal &&
    css`
      flex: none;
      height: auto;
      max-height: none;
    `}
`;

export const WhatsappTemplateTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  background: ${designTokens.colors.gray[50]};
  border-bottom: 1px solid ${designTokens.colors.gray[200]};
  gap: 10px;
  min-height: 56px;
  flex-shrink: 0;
`;

export const WhatsappTemplateTitle = styled.div`
  font-family: ${designTokens.fonts.heading};
  font-style: normal;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 10px;
  color: ${designTokens.colors.gray[800]};
  flex: 1;
  min-width: 0;
  overflow: hidden;

  img {
    flex-shrink: 0;
  }
`;

export const WhatsappTemplateInfo = styled.div`
  display: flex;
  flex-direction: ${(props) =>
    props.iswhatsappTemplateSelected ? "row" : "column"};
  cursor: pointer;
  gap: 2px;
  min-width: 0;
  overflow: hidden;

  ${(props) =>
    props.align === "center" &&
    css`
      align-items: center;
      gap: 8px;
      flex-shrink: 0;
    `}
`;

export const WhatsappTemplateInputContainer = styled.div`
  position: relative;
  min-height: 48px;
  display: flex;
  flex-direction: column;

  ${(props) =>
    props.botFollowUp &&
    css`
      width: 70%;
      min-height: 52px;
      margin-top: 1rem;
    `}
`;

export const WhatsappTemplateButton = styled.button`
  background-color: ${designTokens.colors.gray[100]};
  border: 1px solid ${designTokens.colors.gray[200]};
  border-radius: ${designTokens.radius.full};
  width: 32px;
  height: 32px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease;
  position: relative;
  flex-shrink: 0;

  &:hover {
    background-color: ${designTokens.colors.gray[200]};
  }

  ${(props) =>
    props.isCloseButton &&
    css`
      &:before,
      &:after {
        content: "";
        position: absolute;
        width: 14px;
        height: 2px;
        background-color: ${designTokens.colors.gray[500]};
        border-radius: 1px;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }
    `}
`;

export const ButtonIcon = styled.img`
  width: 16px;
  height: 16px;
  object-fit: contain;
`;

export const WhatsappTemplateLabel = styled.label`
  position: absolute;
  font-family: ${designTokens.fonts.body};
  font-style: normal;
  font-weight: 600;
  font-size: 0.7rem;
  line-height: 1;
  top: -8px;
  background: white;
  color: ${designTokens.colors.gray[600]};
  left: 10px;
  padding: 0 4px;
`;

export const WhatsappTemplateSelect = styled.select`
  width: 100%;
  height: 100%;
  border: 1px solid ${designTokens.colors.gray[200]};
  border-radius: ${designTokens.radius.sm};
  padding: 10px 12px;
  font-family: ${designTokens.fonts.body};
  font-style: normal;
  font-weight: 500;
  font-size: 0.85rem;
  color: ${designTokens.colors.gray[700]};
  background: white;
  cursor: pointer;
  transition: border-color 0.15s ease;

  &:focus {
    outline: none;
    border-color: ${designTokens.colors.primary[500]};
    box-shadow: 0 0 0 3px ${designTokens.colors.primary.ring};
  }

  & > option {
    font-family: ${designTokens.fonts.body};
    font-size: 0.85rem;
  }
`;

export const WhatsappTemplateTitleLabel = styled.span`
  font-family: ${designTokens.fonts.heading};
  font-style: normal;
  font-size: 0.9rem;
  font-weight: 600;
  color: ${designTokens.colors.gray[800]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const WhatsappTemplateInfoLabel = styled.span`
  font-family: ${designTokens.fonts.body};
  font-style: normal;
  font-weight: 400;
  font-size: 0.7rem;
  line-height: 1.3;
  color: ${designTokens.colors.gray[500]};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const WhatsappTemplateRet = styled.span`
  font-family: ${designTokens.fonts.body};
  font-style: normal;
  font-weight: 500;
  font-size: 0.85rem;
  line-height: 1.5;
  text-decoration-line: underline;
  color: ${designTokens.colors.primary[500]};
  transition: color 0.15s ease;

  &:hover {
    color: ${designTokens.colors.primary[600]};
  }
`;

export const WhatsappTemplateReturn = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

export const WhatsappTemplateWarningLabel = styled.span`
  font-family: ${designTokens.fonts.body};
  padding-left: 0.5rem;
  font-size: 0.75rem;
  font-weight: 500;
  color: ${designTokens.colors.gray[500]};
`;

export const WhatsappTemplateContainer = styled.article`
  display: flex;
  flex-direction: column;
  padding: 16px;
  background-color: white;
  border: 1px solid ${designTokens.colors.gray[200]};
  border-radius: ${designTokens.radius.md};
  transition: all 0.15s ease;
  gap: 12px;
  flex-shrink: 0;

  &:hover {
    border-color: ${designTokens.colors.primary[300]};
    box-shadow: ${designTokens.shadows.sm};
  }

  ${(props) =>
    props.iswhatsappTemplateSelected &&
    css`
      padding: 16px;
      background: ${designTokens.colors.gray[50]};
      border-color: ${designTokens.colors.gray[200]};

      &:hover {
        border-color: ${designTokens.colors.gray[200]};
        box-shadow: none;
      }
    `}
`;

export const WhatsappTemplateDescription = styled.div`
  width: 100%;

  ${(props) =>
    props.iswhatsappTemplateSelected &&
    css`
      margin-bottom: 0;
    `}
`;

export const WhatsappTemplateDescriptionTitle = styled.h5`
  font-family: ${designTokens.fonts.heading};
  font-style: normal;
  font-weight: 600;
  font-size: 0.9rem;
  line-height: 1.4;
  color: ${designTokens.colors.gray[800]};
  margin: 0 0 10px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
`;

export const WhatsappTemplateDescriptionText = styled.div`
  font-family: ${designTokens.fonts.body};
  font-style: normal;
  font-weight: 400;
  font-size: 0.85rem;
  line-height: 1.5;
  padding: 12px 14px 28px 14px;
  color: #1f2937;
  background-color: #dcfce7;
  border-radius: ${designTokens.radius.sm};
  position: relative;
  word-wrap: break-word;

  * {
    font-family: ${designTokens.fonts.body};
    font-size: 0.85rem;
    color: #1f2937;
  }

  strong, em, del, span:not(.select-var) {
    color: #1f2937 !important;
  }

  .select-var {
    background-color: ${designTokens.colors.warning[100]};
    color: #1f2937 !important;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 600;
  }
`;

export const WhatsappTemplateSearchContainer = styled.div`
  padding: 12px 16px;
  background: white;
  border-bottom: 1px solid ${designTokens.colors.gray[100]};
  flex-shrink: 0;

  ${(props) =>
    props.templateHead &&
    css`
      flex: 1;
      min-width: 250px;
      padding: 0;
      border-bottom: none;
    `}

  ${(props) =>
    props.contacView &&
    css`
      width: 20.675rem;
      padding: 0;
      margin-left: 1rem;
      border-bottom: none;
    `}
`;

export const WhatsappTemplateLoadingContainer = styled.div`
  min-height: 180px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: ${designTokens.colors.gray[600]};
`;

export const WhatsappTemplateLoadingText = styled.span`
  font-family: ${designTokens.fonts.body};
  font-size: 0.85rem;
  font-weight: 500;
`;

export const WhatsappTemplateDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #dcfce7;
  border-radius: ${designTokens.radius.sm};
  position: relative;
  overflow: hidden;
`;

export const WhatsappTemplateDetails = styled.div`
  position: absolute;
  bottom: 6px;
  right: 10px;
  display: flex;
  align-items: center;
  gap: 6px;

  img {
    width: 14px;
    height: 14px;
    flex-shrink: 0;
  }
`;

export const CurrentTime = styled.span`
  font-family: ${designTokens.fonts.body};
  font-style: normal;
  font-weight: 500;
  font-size: 0.65rem;
  color: ${designTokens.colors.gray[600]};
  white-space: nowrap;
  line-height: 1;
`;

export const WhatsappCustomTemplateBtnIcon = styled.div`
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SuggestionMedia = styled.span`
  font-family: ${designTokens.fonts.body};
  font-style: normal;
  font-weight: 500;
  font-size: 0.8rem;
  line-height: 1.5;
  display: flex;
  align-items: center;
  color: ${designTokens.colors.gray[600]};
  margin: 12px 0;
  padding: 12px;
  background: ${designTokens.colors.warning[50]};
  border-radius: ${designTokens.radius.sm};
  border: 1px solid ${designTokens.colors.warning[100]};
  flex-shrink: 0;
`;

export const WhatsappTemplateCategoryLabel = styled.span`
  font-family: ${designTokens.fonts.body};
  font-size: 0.7rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: ${designTokens.radius.full};
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;

export const WhatsappTemplateCategory = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

// Category badge styles (for inline use)
export const CategoryBadge = styled.span`
  font-family: ${designTokens.fonts.body};
  font-size: 0.7rem;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: ${designTokens.radius.full};
  text-transform: uppercase;
  letter-spacing: 0.02em;

  ${(props) =>
    props.category === "MARKETING" &&
    css`
      background-color: #E9D5FF;
      color: #7C3AED;
    `}

  ${(props) =>
    props.category === "UTILITY" &&
    css`
      background-color: ${designTokens.colors.warning[100]};
      color: ${designTokens.colors.warning[600]};
    `}
`;

// Header actions container for the right side buttons
export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;
